import { AddressBookMapper } from '../AddressBookMapper.js';

class RecipientAddressesMapper {
  static createRecipientAddressesFromResponse(response) {
    return response.map(AddressBookMapper.createAddressBookFromResponse);
  }
}

export { RecipientAddressesMapper };
//# sourceMappingURL=RecipientAddressesMapper.js.map
